import { createContext } from 'react';

const ContextApi = createContext();

export default ContextApi;